export const enum NumberType {
    ORGANIZATION = 'ORGANIZATION',
    GLOBAL = 'GLOBAL'
}